import React, { useCallback, useRef, useState } from 'react';
import Typography from './Typography';
import CopyToClipboard from 'react-copy-to-clipboard';
import Icon from './Icon';
import Row from 'components/Common/Row';

const CopyInput = ({ text }: { text: string }) => {
  const textParentRef = useRef<HTMLDivElement>(null);

  const [isConfirming, setIsConfirming] = useState<boolean>(false);

  const selectText = useCallback(() => {
    const parent = textParentRef.current;

    if (!parent) return;

    const element = parent.children[0];

    const range = document.createRange();
    const selection = window.getSelection();

    if (selection) {
      range.selectNodeContents(element);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }, []);

  const showConfirm = useCallback(() => {
    setIsConfirming(true);

    setTimeout(() => {
      setIsConfirming(false);
    }, 2000);
  }, []);

  return (
    <Row
      centerAlign
      spaceBetween
      ref={textParentRef}
      style={{
        padding: '3px 12px',
        border: '1px solid var(--color-border-primary)',
        borderRadius: '8px',
      }}
    >
      <div style={{ cursor: 'pointer', display: 'flex' }}>
        <Typography.Body type="Body 12" onClick={selectText}>
          {text}
        </Typography.Body>
      </div>

      <CopyToClipboard text={text}>
        <Row centerAlign onClick={showConfirm} style={{ cursor: 'pointer' }}>
          <div style={{ display: 'flex', marginRight: '4px' }}>
            <Icon
              icon={isConfirming ? 'checkmark' : 'copy'}
              color={'var(--color-info-v2)'}
              width={12}
              height={12}
            />
          </div>
          <Typography.Body type="Body 12" color={'var(--color-info-v2)'}>
            {isConfirming ? 'Copied!' : 'Copy'}
          </Typography.Body>
        </Row>
      </CopyToClipboard>
    </Row>
  );
};

export default CopyInput;
